import SysStoreList from "../component/SysStoreList";
import React from "react";

const SysStoreListContainer = ({ pageId }) => (<SysStoreList pageId={pageId}/>)

export default SysStoreListContainer;